<p-toast position="bottom-right">
  <ng-template let-message pTemplate="message">
    <div class="p-toast-message-text">
      <div class="p-toast-summary">{{ message.summary }}</div>
      <div class="p-toast-detail" *ngIf="message.detail">{{ message.detail }}</div>
      <button *ngIf="toastReferenceCode(message)"
              pButton pRipple type="button" icon="fa-solid fa-clipboard"
              class="p-button-text p-button-sm copy-reference-code-button"
              [cdkCopyToClipboard]="toastReferenceCode(message)"
              (cdkCopyToClipboardCopied)="copiedToClipboard()"
              pTooltip="Copy reference code">
        Copy reference code
      </button>
    </div>
  </ng-template>
</p-toast>
<header class="site-header">
  <div class="left">
    <p-menubar [model]="menuBarItemsLeft">
      <ng-template pTemplate="start">

        <app-logo></app-logo>
        <!--        <ul class="inline-ul">-->
        <!--          <li class="logo">-->
        <!--        <span (click)="go(HeaderWithMenuComponent.Menu.TRADESORDERS)"-->
        <!--              class="logo-img out"></span>-->
        <!--            <div>-->
        <!--              <span class="name-img"></span>-->
        <!--              <span class="customer-name">{{customerName}}</span>-->
        <!--            </div>-->
        <!--          </li>-->
        <!--        </ul>-->
      </ng-template>
    </p-menubar>
  </div>
  <div class="center">
  </div>
  <div class="right">
    <p-menubar [model]="menuBarItemsRight">
    </p-menubar>
    <ul class="inline-ul">
      <li class="li-exit">
<!--        <button pButton pRipple (click)="userFormVisible=true;" type="button" class="p-button-info p-button-text"-->
<!--                icon="fas fa-user"></button>-->
        <app-services-health *ngIf="showHealthCheck" [autoReload]="appConfigService.healthCheckAutoReload"></app-services-health>
        <button pButton pRipple (click)="helpDialogVisible=true" type="button"
                class="p-button-info p-button-text w-20px"
                icon="fa-solid fa-info"></button>
        <div class="user">
          <span>
            <span *ngIf="!userInfo">
<!--              {{ 'header.guest' | translate }}-->
            </span>
            <span *ngIf="userInfo">
              <span *ngIf="userInfo.firstName && userInfo.lastName && userInfo.roles" class="user-info"
                    (click)="userFormVisible=true;">
                <i class="fas fa-user"></i>
                <span class="top-user-info">
                  <span>
                    {{userInfo.firstName}}
                  </span>
                  <span>
                    {{ userInfo.lastName}}
                  </span>
                </span>
              </span>
              <span *ngIf="userInfo.username && !userInfo.firstName" class="user-info-username">
                {{userInfo.username}}
              </span>
            </span>
          </span>
        </div>
        <app-notification *ngIf="appConfigService.notificationEnabled"></app-notification>
        <button pButton pRipple (click)="logInOut()" type="button" class="p-button-info p-button-text"
                icon="fa fa-sign-out-alt"></button>
      </li>
    </ul>
  </div>
</header>

<app-user-form [(formRecord)]="userInfo"
                    [(dialogFormVisible)]="userFormVisible"
                    (onSave)="updateUser($event)"></app-user-form>

<app-help-dialog [(dialogFormVisible)]="helpDialogVisible"></app-help-dialog>
